<template>
  <div>
    <Pane />

    <div class="container">
      <div class="operation" style="margin-bottom: 10px; display: flex; gap: 5px">
        <a-button @click="addRow">新增行</a-button>
        <a-button @click="copyRow">复制行</a-button>
        <a-button @click="deleteRow">删除行</a-button>
        <a-button @click="batchImportRow">批量导入行</a-button>
        <a-button @click="regenerateAssetCode">生成资产编码</a-button>
        <!-- 隐藏的文件输入 -->
        <input 
          type="file" 
          ref="fileInput" 
          style="display: none" 
          @change="handleFileImport" 
          accept=".xlsx, .xls, .csv"
        >
      </div>
      <a-table
        bordered
        :dataSource="list"
        :row-selection="{
          selectedRowKeys,
          onChange: onSelectChange,
        }"
        :loading="tableLoading"
        :pagination="false"
        :scroll="{ y:350 }"
      >
        <a-table-column title="序号" width="50px">
          <template slot-scope="text, row, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="资产编码" data-index="assetCode" width="100px">></a-table-column>
        <a-table-column title="资产类别">
          <template slot-scope="text, row, index">
            <a-select v-model="text.categoryId" style="width: 100px" @change="categoryChange(text,index)">
              <a-select-option
                v-for="item in assetsCategoryList"
                :key="item.id"
                :value="item.id"
              >
                <div>
                  {{ item.subCategoryName }}
                </div>
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="品牌型号">
          <template slot-scope="text">
            <a-input v-model="text.brandModel" />
          </template>
        </a-table-column>
        <a-table-column title="采购日期">
          <template slot-scope="text">
            <a-date-picker
              placeholder="请选择日期"
              v-model="text.procurementTime"
              format="YYYY-MM-DD"
            />
          </template>
        </a-table-column>
        <a-table-column title="采购价格(元)">
          <template slot-scope="text">
            <a-input-number v-model="text.purchasePrice" />
          </template>
        </a-table-column>
        <a-table-column title="资产负责人" width="100px">
          <template slot-scope="text, row, index">
            <EmployeeSelector
              @change="
                (arr) => {
                  if (arr.length) {
                    selectedUser = arr[0];
                    list[index].responsiblePersonName = arr[0].name;
                    list[index].responsiblePersonId = arr[0].userId;
                  } else {
                    selectedUser = {};
                    list[index].responsiblePersonName = '';
                    list[index].responsiblePersonId = '';
                  }
                }
              "
              :value="selectedUser.name ? [selectedUser] : []"
            >
              <a-button
                block
                style="text-align: left"
                @click="showEmployeeSelector(index)"
              >
                <div v-if="text.responsiblePersonName">
                  {{ text.responsiblePersonName }}
                </div>
                <div v-else>&nbsp;</div>
              </a-button>
            </EmployeeSelector>
          </template>
        </a-table-column>
        <a-table-column title="资产位置(部门)">
          <template slot-scope="text">
            <a-select
              placeholder=""
              show-search
              :filter-option="$selectFilterOption"
              v-model="text.deptId"
              style="width: 100px"
              @change="
                () => {
                  text.deptName =
                    organizationList.find((item) => item.id === text.deptId)
                      ?.uniqueName || '';
                }
              "
            >
              <a-select-option
                v-for="item in organizationList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.uniqueName }}
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="财务编码" width="200px">
          <template slot-scope="text">
            <a-input v-model="text.financialCode"/>
          </template>
        </a-table-column>
        <a-table-column title="启用日期">
          <template slot-scope="text">
            <a-date-picker
              v-model="text.startTime"
              format="YYYY-MM-DD"
            />
          </template>
        </a-table-column>
        <a-table-column title="资产状态">
          <template slot-scope="text">
            <a-select v-model="text.status" style="width: 100px">
              <a-select-option
                v-for="item in statusList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="报废方式">
          <template slot-scope="text">
            <a-select v-model="text.scrapMethod">
              <a-select-option
                  v-for="item in ['平均年限法']"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="报废时限(月)">
          <template slot-scope="text">
            <a-input-number :min="1" v-model="text.scrapLimitMonths" />
          </template>
        </a-table-column>
        <a-table-column title="净残值率">
          <template slot-scope="text">
            <a-input-number :min="0" :max="1" v-model="text.netSalvageRate" />
          </template>
        </a-table-column>
        <a-table-column title="备注">
          <template slot-scope="text">
            <a-input v-model="text.remark" />
          </template>
        </a-table-column>
      </a-table>
      <div style="margin-top: 10px">
        合计数量: {{ list.length }}
      </div>
      <div class="center">
        <a-space>
          <a-button type="primary" @click="handleSubmit" :loading="loading"
            >保存</a-button
          >
          <a-button @click="$close($route.path)">关闭</a-button>
        </a-space>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchList as fetchEmployeeList } from '@/api/employee'
import request from "@/api/request";
import { mapGetters } from "vuex";
import organization from "@/mixins/organization";
import EmployeeSelector from "@/components/employee-selector";
import moment from "moment";
import XLSX from "xlsx"; // 导入xlsx库
function add(data) {
  return request({
    url: "/office-service/fixed-asset/batch-add",
    data,
    method: "post",
  });
}
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset-category/list",
    data,
    method: 'post'
  });
}
function genCode(data) {
    return request({
    url: "/office-service/fixed-asset/gen-code/batch",
    data,
    method: 'post'
  });
}
export default {
  name: "addFixedAssetsBook",
  mixins: [organization],
  data() {
    return {
      index: 0,
      assetsCategoryList: [],
      selectedUser: {},
      list: [],
      loading: false,
      tableLoading: false,
      selectedRowKeys: [],
      employeeList: []
    };
  },
  components: {
    EmployeeSelector,
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("fixed_asset_status");
    },
  },

  methods: {
    categoryChange(text,index){
      const category = this.assetsCategoryList.find((item) => item.id === text.categoryId)
      console.log(category)
      this.list[index].status = category.status
      this.list[index].scrapMethod = category.scrapMethod
      this.list[index].scrapLimitMonths = category.scrapLimitMonths
      this.list[index].netSalvageRate = category.netSalvageRate
    },
    showEmployeeSelector(index) {
      this.index = index;
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys;
    },
    addRow() {
      this.list.push({
        assetCode: "",
        categoryId: "",
        brandModel: "",
        purchasePrice: "",
        responsiblePersonId: "",
        responsiblePersonName: "",
        deptId: "",
        deptName: "",
        financialCode: "",
        startTime: "",
        status: "",
        category: {},
        scrapMethod: "",
        scrapLimitMonths: "",
        netSalvageRate: "",
        remark: "",
      });
    },
    copyRow() {
      const selectedRows = this.list.filter((row, index) =>
        this.selectedRowKeys.includes(index)
      );
      selectedRows.forEach((row) => {
        this.list.push({ ...row });
      });
      this.selectedRowKeys = [];
    },
    deleteRow() {
      const selectedRows = this.list.filter((row, index) =>
        this.selectedRowKeys.includes(index)
      );
      selectedRows.forEach((row) => {
        this.list.splice(this.list.indexOf(row), 1);
      });
      this.selectedRowKeys = [];
    },
    // 批量导入行：触发文件选择
    batchImportRow() {
      this.$refs.fileInput.click();
    },
    // 处理文件导入
    handleFileImport(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.tableLoading = true;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array", cellDates: true });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          if (jsonData.length < 2) {
            this.$message.error("Excel文件无数据");
            return;
          }

          const headers = jsonData[1];
          const rows = jsonData.slice(2);
          // 根据标题查找列索引
          const index序号 = headers.indexOf("序号");
          const index财务编码 = headers.indexOf("财务编码");
          const index启用日期 = headers.indexOf("启用日期");
          const index类别 = headers.indexOf("类别");
          const index品牌型号 = headers.indexOf("品牌型号");
          const index原值 = headers.indexOf("原值");
          const index资产负责人 = headers.indexOf("资产负责人");
          const index归属部门 = headers.indexOf("归属部门");
          const index状态 = headers.indexOf("状态");
          const index采购时间 = headers.indexOf("采购时间");
          const index报废方式 = headers.indexOf("报废方式");
          const index报废时限 = headers.indexOf("报废时限（月）");
          const index净残值率 = headers.indexOf("净残值率");
          const index备注 = headers.indexOf("备注");

          // 检查必要列是否存在
          if (
            index财务编码 === -1 ||
            index启用日期 === -1 ||
            index类别 === -1 ||
            index原值 === -1 ||
            index资产负责人 === -1 ||
            index归属部门 === -1 ||
            index状态 === -1 ||
            index采购时间 === -1
          ) {
            this.$message.error("Excel文件缺少必要列");
            return;
          }

          const newList = rows.map((row, index) => {
            // 获取单元格值
            const financialCode = row[index财务编码];
            const startTime = row[index启用日期] ? moment(row[index启用日期]) : null;
            const categoryName = row[index类别];
            const brandModel = row[index品牌型号];
            const purchasePrice = row[index原值];
            const responsiblePersonName = row[index资产负责人];
            const deptName = row[index归属部门];
            const statusText = row[index状态];
            const procurementTime = row[index采购时间] ? moment(row[index采购时间]) : null;
            const scrapMethod = row[index报废方式] || "平均年限法";
            const scrapLimitMonths = row[index报废时限];
            const netSalvageRate = row[index净残值率];
            const remark = row[index备注];
            // 映射资产类别ID
            const category = this.assetsCategoryList.find(
              (item) => item.subCategoryName === categoryName.split("-")[1]
            );
            const categoryId = category ? category.id : "";

            // 映射部门ID
            const dept = this.organizationList.find(
              (item) => item.uniqueName === deptName
            );
            const deptId = dept ? dept.id : "";

            // 映射状态值
            const statusItem = this.statusList.find(
              (item) => item.name === statusText
            );
            const status = statusItem ? statusItem.value : "";
            const responsiblePersonId = this.employeeList.find(
              (item) => item.name === responsiblePersonName && item.deptName === deptName
            )?.userId;
            return {
              assetCode: "", // 资产编码留空，后续生成
              categoryId: categoryId,
              brandModel: brandModel,
              purchasePrice: purchasePrice,
              responsiblePersonId: responsiblePersonId, // Excel中无负责人ID，留空
              responsiblePersonName: responsiblePersonName,
              deptId: deptId,
              deptName: deptName,
              financialCode: financialCode,
              startTime: startTime,
              procurementTime: procurementTime,
              status: status,
              scrapMethod: scrapMethod,
              scrapLimitMonths: scrapLimitMonths,
              netSalvageRate: netSalvageRate,
              remark: remark
            };
          });

          this.list = [...this.list, ...newList];
          this.$message.success(`成功导入 ${newList.length} 条数据`);
          this.tableLoading = false;
        } catch (error) {
          this.$message.error("导入失败: " + error.message);
          this.tableLoading = false;
        }
      };
      reader.onerror = () => {
        this.$message.error("文件读取失败");
      };
      reader.readAsArrayBuffer(file);
    },
    regenerateAssetCode() {
      if(this.list.length === 0) return
      this.tableLoading = true;
      //资产类别必填校验
      if (this.list.some((item) => !item.categoryId)) {
        this.$message.error("请选择资产类别");
        this.tableLoading = false;
        return;
      }
      
        genCode(this.list).then((res) => {
          res.forEach((item, index) => {
            this.list[index].assetCode = item;
          })
          this.tableLoading = false;
        });
        //index转成001的格式
        // let indexStr = (index + 1).toString();
        // while (indexStr.length < 3) {
        //   indexStr = "0" + indexStr;
        // }
        // if(row.category){
        //   if(row.startTime){
        //     row.assetCode = row.category.subCategoryCode + moment(row.startTime).format('YYYYMM') + indexStr
        //   }else{
        //     row.assetCode = row.category.subCategoryCode + moment().format('YYYYMM') + indexStr
        //   }
          
        // }
    },
    handleSubmit() {
      this.loading = true;
      if (this.list.some((item) => !item.responsiblePersonId)) {
        const index = this.list.findIndex((item) => !item.responsiblePersonId);
        this.$message.error(`第${index + 1}行负责人不存在，请重新选择负责人`);
        this.loading = false;
        return;
      }      
      //资产类别必填校验
      if (this.list.some((item) => !item.categoryId)) {
        this.$message.error("请选择资产类别");
        this.loading = false;
        return;
      }
      //资产编码必填校验
      if (this.list.some((item) => !item.assetCode)) {
        this.$message.error("请生成资产编码");
        this.loading = false;
        return;
      }
      //财务编码必填校验
      if (this.list.some((item) => !item.financialCode)) {
        this.$message.error("请填写财务编码");
        this.loading = false;
        return;
      }
      //资产编码重复校验
      const assetCodeList = this.list.map((item) => item.assetCode);
      if (new Set(assetCodeList).size !== assetCodeList.length) {
        this.$message.error("资产编码冲突，请点击生成资产编码按钮再次生成");
        this.loading = false;
        return;
      }
      //财务编码重复校验，提示冲突行序号
      const financialCodeList = this.list.map((item) => item.financialCode);
      const financialCodeMap = {};
      financialCodeList.forEach((code, index) => {
        if (financialCodeMap[code]) {
          financialCodeMap[code].push(index + 1);
        } else {
          financialCodeMap[code] = [index + 1];
        }
      });
      const conflictList = Object.values(financialCodeMap).filter(
        (arr) => arr.length > 1
      );
      if (conflictList.length) {
        const conflictMessage = conflictList
         .map((arr) => `第${arr.join("、")}行`)
         .join("、");
        this.$message.error(`财务编码冲突，请检查${conflictMessage}的财务编码`);
        this.loading = false;
        return;
      }
      this.list.forEach((item) => {
        if(item.startTime){
          item.startTime = moment(item.startTime).format("YYYY-MM-DD");
        }
      });
      add(this.list)
       .then(() => {
          this.$close(this.$route.path);
        })
       .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    fetchList({
        pageNum: 1,
        pageSize: 10000,
      })
    .then((res) => {
      if (Array.isArray(res.list)) {
        this.assetsCategoryList = res.list;
      }
    })
    fetchEmployeeList()
     .then((res) => {
        if (Array.isArray(res)) {
          this.employeeList = res;
        }
      })
  }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 10px;
}

.center {
  margin-top: 80px;
}
</style>
